import { Component, OnInit } from '@angular/core';
import { Task } from '@models/imported/SagaSchema/Task';
import { CurrentTaskService } from '../../services/current-task/current-task.service';

@Component({
  selector: 'app-planned-mission-details-view',
  templateUrl: './planned-mission-details-view.component.html',
  styleUrls: ['./planned-mission-details-view.component.scss']
})
export class PlannedMissionDetailsViewComponent implements OnInit {
  task: Task;

  constructor(private currentTask: CurrentTaskService) {}

  ngOnInit() {
    this.task = this.currentTask.current;
  }
}
